module.exports = __webpack_public_path__ + "img/center.1b432337.svg";